import React from 'react'
import { Input } from '@material-ui/core'
import { Switch } from 'antd'

export default class MonitorProductGroupManagementColumnModel {
    static MonitorProductGroupManagementColumn = [
      {
        title: 'Type',
        align: 'left',
        field: 'type',

        validate: (rowData: any) => {
          if (rowData.type == null || rowData.type === '') {
            return { isValid: false, helperText: 'Type is required' };
          }
          
          const numericType = Number(rowData.type);
          
          if (!Number.isInteger(numericType)) {
            return { isValid: false, helperText: 'Type must be a valid integer' };
          }
          
          if (numericType < 1) {
            return { isValid: false, helperText: 'Type must be greater than or equal to 1' };
          }
          
          return { isValid: true };
        },
      },
      // {
      //   title: 'Color',
      //   align: 'left',
      //   field: 'color',
      //   validate: (rowData: any) => rowData.color === '' ? { isValid: false, helperText: 'Required' } : true
      // },
      {
        title: 'Name',
        align: 'left',
        field: 'name',
        validate: (rowData: any) => rowData.name === '' ? { isValid: false, helperText: 'Required' } : true
      },
      {
        title: 'Active',
        align: 'left',
        field: 'active',
        render: (rowData: any) => (
          <Switch checked={rowData.active} disabled />
        ),
        editComponent: (props: any) => {
          return (
            <Switch checked={props.value} onChange={(checked: boolean) => props.onChange(checked)} />
          )
        }
      }
    ]
}